<template>
  <div class="filter-row">
    <div class="fa-pull-right filter-group">
      <div class="event-type-filter responsive-filter">
        <div class="checkbox-wrapper" v-for="(type, index) in eventTypes" :key="index">
          <input
            class="custom-checkbox"
            :id="`eventTypeResponsive_${type}`"
            type="checkbox"
            :checked="selectedSessionTypes.indexOf(type) > -1"
            :class="{
              'custom-checkbox-red': type === eventTypes.GAME,
              'custom-checkbox-purple': type === eventTypes.OTHER,
              'custom-checkbox-green': type === eventTypes.TRAINING,
              'custom-checkbox-orange': type === eventTypes.INDIVIDUAL
            }"
            @click="filterBySessionTypeAndLog(type, $event)" />
          <label :for="`eventTypeResponsive_${type}`">
            {{type === eventTypes.GAME ? eventTypesTrans.game : ""}}
            {{type === eventTypes.OTHER ? eventTypesTrans.other : ""}}
            {{type === eventTypes.TRAINING ? eventTypesTrans.training : ""}}
            {{type === eventTypes.INDIVIDUAL ? eventTypesTrans.individual : ""}}
            </label>
        </div>
      </div>

      <div class="team-filter-wrapper">
        <b-dropdown id="ddown1" class="btn-group dropdown calendar-filter-btn">
          <template slot="button-content" v-if="calendarTeamsFetched">
            <template v-if="calendarSelectedTeams.length !== calendarTeams.length">
              <span class="text-ellipsis-overflow" v-for="(selectedTeam, i) in calendarSelectedTeams" :key="i">{{selectedTeam.teamName}}</span>
            </template>
            <template v-if="calendarSelectedTeams.length === calendarTeams.length">{{ $t('CALENDAR.calendarFilter.allTeams')}}</template>
          </template>

          <b-dropdown-item
            @click.prevent="selectAllTeams"
            :class="{ active: calendarSelectedTeams.length === calendarTeams.length}">{{ $t('CALENDAR.calendarFilter.allTeams')}}</b-dropdown-item>

          <b-dropdown-divider></b-dropdown-divider>

          <template v-if="calendarTeams.length">
            <b-dropdown-item
              v-for="(team, i) in calendarTeams"
              :key="i"
              @click.prevent="onSelectedTeamsChange(team)"
              :class="{'active': isTeamSelected(team.teamId) && calendarSelectedTeams.length !== calendarTeams.length}">

              <span class="text-ellipsis-overflow">{{team.teamName}}</span>
            </b-dropdown-item>
          </template>
        </b-dropdown>
      </div>

      <b-button-group class="switch-btn-group">
        <b-button @click="changeCalendarViewAndLog(calendarViewModes.WEEK)" :class="{'active': previewMode === calendarViewModes.WEEK}">{{ $t('CALENDAR.calendarFilter.weekly')}}</b-button>
        <b-button @click="changeCalendarViewAndLog(calendarViewModes.MONTH)" :class="{'active': previewMode === calendarViewModes.MONTH}">{{ $t('CALENDAR.calendarFilter.monthly')}}</b-button>
      </b-button-group>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { CALENDAR_VIEW_MODES } from '@/constants/CalendarConsts'
import { SESSION_TYPES } from '@/constants/SessionConsts'
import { CHANGE_CALENDAR_SESSION_TYPES } from '@/store/action.types'
import { mapActions } from 'vuex'

export default {
  name: 'CalendarFilter',
  props: [
    'title',
    'onCalendarPreviewChange',
    'viewDate',
    'previewMode',
    'onViewDateChange',
    'onSessionTypeFilterChange',
    'selectedSessionTypes',
    'calendarTeams',
    'calendarSelectedTeams',
    'responsive',
    'changeSelectedTeams',
    'selectedEntity',
    'calendarTeamsFetched'
  ],
  data () {
    return {
      eventTypes: SESSION_TYPES,
      calendarViewModes: CALENDAR_VIEW_MODES,
    }
  },
  computed: {
    calendarTitle () {
      if (this.previewMode === CALENDAR_VIEW_MODES.MONTH) {
        return moment(this.title).format('MMMM YYYY')
      } else {
        return `WEEK ${moment(this.title).week()} OF ${moment(this.title).format('YYYY')}`
      }
    },
    eventTypesTrans() {
      return {
        game : this.$t('CALENDAR.calendarFilter.gameTypes.game'),
        training : this.$t('CALENDAR.calendarFilter.gameTypes.training'),
        other : this.$t('CALENDAR.calendarFilter.gameTypes.other'),
        individual : this.$t('CALENDAR.calendarFilter.gameTypes.individual')
      } 
    }
  },
  methods: {
    ...mapActions({
      changeCalendarSessionTypes: CHANGE_CALENDAR_SESSION_TYPES
    }),
    onSelectedTeamsChange (team) {
      this.$amplitude.logEvent('pwa: change calendar team', {teamType: "TEAM"})
      this.changeSelectedTeams([team])
    },
    selectAllTeams () {
      this.$amplitude.logEvent('pwa: change calendar team', {teamType: "ALL_TEAMS"})
      this.changeSelectedTeams(this.calendarTeams)
    },
    filterBySessionTypeAndLog (type, $e) {
      this.$amplitude.logEvent('pwa: change calendar filter', {sessionType: type, isChecked: $e.target.checked})
      this.changeCalendarSessionTypes({ payload: { type, isAdding: $e.target.checked } })
    },
    changeCalendarViewAndLog (previewMode) {
      this.$amplitude.logEvent('pwa: change calendar view type', {type: previewMode + "LY"})
      this.onCalendarPreviewChange(previewMode)
    },
    isTeamSelected (teamId) {
      return this.calendarSelectedTeams.some(t => t.teamId === teamId)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/scss/components/_calendar-filter.scss';
</style>
